import React, { useState } from 'react';
import { getImagenUrl } from '../api';

export default function ImagenProducto({ imagen_url, thumb_url, size = 40, refreshKey = 0 }) {
  const [imgError, setImgError] = useState(false);
  const fullSrc = getImagenUrl(imagen_url);
  const thumbSrc = getImagenUrl(thumb_url);
  const src = thumbSrc || fullSrc;
  if (!src || imgError) {
    return (
      <span style={{ color: 'var(--agx-faint)', fontSize: '11px', fontStyle: 'italic' }}>
        Sin imagen
      </span>
    );
  }
  const cacheBust = refreshKey ? `?v=${refreshKey}` : '';
  return (
    <img
      key={`${src}-${refreshKey}`}
      src={`${src}${cacheBust}`}
      alt=""
      onError={() => setImgError(true)}
      style={{
        width: size,
        height: size,
        borderRadius: 6,
        objectFit: 'cover',
        background: '#f1f3f4',
      }}
    />
  );
}
